import _ from 'lodash'
import {findParams} from "./js-to-string";
import {stringInject} from "./stringInject";
import getParamsFromString from "./getParamsFromString";


const getValueFromParamsList = (params, screenName, listName, globalValues, row, action = {}) => {
    let newGlobalValues = {...globalValues, [listName]: row, doc: row};
    let newValues = {};

    if (action.paramType === 'script') {
        newValues = getParamsFromString(action.script, newGlobalValues, screenName);
        return newValues
    }

    if (_.isEmpty(params) === false) {
        for (const param of Object.keys(params)) {
            let value = findParams(params[param], newGlobalValues, screenName).objectValues;
            //this mean that the value does not have the key, return value how it present
            if (param === 'value') {
                newValues = stringInject(params[param], value)
            } else {
                //here value insert in object with key, as key will be [param] -> {[param]: value}
                newValues = {[param]: stringInject(params[param], value), ...newValues}
            }
        }
    } else {
        newValues = '';
    }
    return newValues
};

export default getValueFromParamsList;
